import { render, staticRenderFns } from "./ScrollArea.vue?vue&type=template&id=7846e1d6&scoped=true&"
import script from "./ScrollArea.vue?vue&type=script&lang=js&"
export * from "./ScrollArea.vue?vue&type=script&lang=js&"
import style0 from "./ScrollArea.vue?vue&type=style&index=0&id=7846e1d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7846e1d6",
  null
  
)

export default component.exports